export const compareByOperator = (a: string, operator: Comparators, b: string) => {
  switch (operator) {
    case '>':
      return a > b;
    case '<':
      return a < b;
    case '>=':
      return a >= b;
    case '<=':
      return a <= b;
    case '===':
      return a === b;
    case '!==':
      return a !== b;
    default:
      return false;
  }
};
